import React, {useRef, useEffect, useState} from "react";
import Header from "../../components/Header";
import {useNavigate} from "react-router-dom";
import "./Profile.scss";
import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../../components/Footer";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import countryList from "../../assets/countryList.json";
import Button from "react-bootstrap/Button";
import ProfileComponent from "../../components/Profile/ProfileComponent";
import {toast} from "react-toastify";
import {Modal} from "react-bootstrap";

function Profile() {
    useEffect(() => {
        document.title = "Geoticket - Profilo";
    }, []);
    const navigate = useNavigate()

    const formPasswordRef = useRef();
    const [showDeleteAccount, setShowDeleteAccount] = useState(false);

    const [user, setUser] = useState({
        email: "",
        firstname: "",
        lastname: "",
        phone: "",
        country: "",
        fiscal_code: ""
    });

    useEffect(() => {
        global.permission().then((user) => {
            setUser(user);
        }).catch(error => {
            navigate(`/login`);
        });
    }, []);

    let editData = (e) => {
        e.preventDefault();
        const email = e.target.elements.email.value;
        const firstname = e.target.elements.firstname.value;
        const lastname = e.target.elements.lastname.value;
        const phone = e.target.elements.phone.value;
        const country = e.target.elements.country.value;
        const fiscal_code = e.target.elements.fiscal_code.value;

        let data = {email, firstname, lastname};
        if (phone.trim() !== "")
            data.phone = phone;
        if (country.trim() !== "")
            data.country = country;
        if (fiscal_code.trim() !== "")
            data.fiscal_code = fiscal_code;
        fetch(global.route.editUser, {
            method: "post", credentials: 'include',
            body: global.getFormData(data)
        })
            .then(response => {
                if (response.status === 200) {
                    toast.success("Dati aggiornati con successo!");
                    response.json().then(response => {
                        setUser(response.user);
                    });
                } else {
                    global.catchError(response);
                }
            });
    }


    let editPassword = (e) => {
        e.preventDefault();
        const old_password = e.target.elements.old_password.value;
        const password = e.target.elements.password.value;

        fetch(global.route.updatePassword, {
            method: "post", credentials: 'include',
            body: global.getFormData({
                old_password: old_password,
                password: password
            })
        })
            .then(response => {
                if (response.status === 200) {
                    toast.success("Password aggiornata con successo!");
                    formPasswordRef.current.reset();

                } else {
                    global.catchError(response);
                }
            });
    }

    let deleteAccount = (e) => {
        e.preventDefault();
        const password = e.target.elements.password.value;

        fetch(global.route.userDelete, {
            method: "post", credentials: 'include',
            body: global.getFormData({
                password: password
            })
        })
            .then(response => {
                if (response.status === 200) {
                    setShowDeleteAccount(false);
                    toast.success("Account eliminato con successo! Verrai disconnesso tra 5 secondi");
                    setTimeout(() => {
                        window.location.href = "/";
                    }, 5000);
                } else {
                    global.catchError(response);
                }
            });
    }

    return (
        <div>
            <Header/>
            <div className="container container-profile" style={{paddingTop: 86, minHeight: "100vh"}}>
                <div className="row">
                    <div className="col-md-4 mb-4">
                        <ProfileComponent/>
                    </div>
                    <div className="col-md-8 mb-4">
                        <div className="card">
                            <div className="card-body">
                                <h4>Modifica dati</h4>
                                <Form onSubmit={(e) => editData(e)}>
                                    <Form.Group className="mb-3" controlId="email">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control type="email" placeholder="Inserisci email" value={user.email}/>
                                    </Form.Group>

                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="firstname">
                                                <Form.Label>Nome</Form.Label>
                                                <Form.Control type="text" placeholder="Nome" value={user.firstname}/>

                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="lastname">
                                                <Form.Label>Cognome</Form.Label>
                                                <Form.Control type="text" placeholder="Cognome" value={user.lastname}/>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Form.Group className="mb-3" controlId="phone">
                                        <Form.Label>Telefono <small>(opzionale)</small></Form.Label>
                                        <Form.Control type="phone" placeholder="Inserisci il numero di telefono"
                                                      value={user.phone}/>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="country">
                                        <Form.Label>Paese <small>(opzionale)</small></Form.Label>
                                        <Form.Select aria-label="Default select example" value={user.country}>
                                            <option>Seleziona il paese</option>
                                            {countryList.map((item) => (
                                                <option key={item.code} value={item.name}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="fiscal_code">
                                        <Form.Label>Codice fiscale <small>(opzionale)</small></Form.Label>
                                        <Form.Control type="fiscal_code" placeholder="Inserisci il codice fiscale"
                                                      value={user.fiscal_code}/>
                                    </Form.Group>
                                    <div className="d-flex justify-content-center">
                                        <Button className={"btn-orange"} type="submit">Aggiorna dati</Button>
                                    </div>
                                </Form>
                                <hr/>
                                <h4>Modifica password</h4>
                                <Form onSubmit={(e) => editPassword(e)} ref={formPasswordRef}>
                                    <Form.Group className="mb-3" controlId="old_password">
                                        <Form.Label>Vecchia password</Form.Label>
                                        <Form.Control type="password" placeholder="Vecchia password"/>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="password">
                                        <Form.Label>Nuova password</Form.Label>
                                        <Form.Control type="password" placeholder="Nuova password"/>
                                        <Form.Text className="text-muted">
                                            <small className="text-muted">La password deve contenere almeno 8
                                                caratteri</small><br/>
                                            <small className="text-muted">La password deve contenere almeno un carattere
                                                MAIUSCOLO</small><br/>
                                            <small className="text-muted">La password deve contenere almeno un
                                                numero</small>
                                        </Form.Text>
                                    </Form.Group>
                                    <div className="d-flex justify-content-center">
                                        <Button className={"btn-orange"} type="submit">Aggiorna password</Button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                        <div className={"d-flex justify-content-center mt-4"}>
                            <Button variant={"danger"} onClick={() => setShowDeleteAccount(true)}>Elimina
                                account</Button>
                        </div>
                    </div>


                </div>
            </div>
            <Footer/>
            <Modal show={showDeleteAccount} onHide={() => {
                setShowDeleteAccount(false)
            }}>
                <Modal.Header closeButton>
                    Eliminazione account
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={(e) => deleteAccount(e)} ref={formPasswordRef}>
                        <Form.Group className="mb-3" controlId="old_password">
                            <Form.Label>Conferma password per eliminare l'account</Form.Label>
                            <Form.Control type="password" placeholder="Password"/>
                        </Form.Group>
                        <div className="d-flex justify-content-center">
                            <Button variant={"danger"} type="submit">Elimina account</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Profile;